import { HttpContext } from '@angular/common/http';
import { REQUIRES_AUTH } from '../interceptors/auth-context.token';

/**
 * Base repository class with common HTTP context utilities.
 * Provides helper methods for creating authentication contexts.
 */
export abstract class BaseRepository {
  /**
   * Create HTTP context for authenticated BFF requests.
   * Marks request to include session cookies via auth interceptor.
   *
   * @returns HttpContext with REQUIRES_AUTH flag set to true
   *
   * @example
   * ```typescript
   * return this.http.get<User[]>(`${this.apiUrl}/api/v1/users`, {
   *   context: this.authContext()
   * });
   * ```
   */
  protected authContext(): HttpContext {
    return new HttpContext().set(REQUIRES_AUTH, true);
  }
}
